import { HttpParams } from '@angular/common/http';

export const MakeHttpParams = function(params: {}): HttpParams {
  return Object.getOwnPropertyNames(params).reduce((httpParams, key) => httpParams.set(key, params[key]), new HttpParams());
};



// WEBPACK FOOTER //
// ./src/app/shared/helpers/params.helper.ts